<template>
	<div class="content">
		<div class="modal" v-if="state === 'validate'">
      <BatchPreview :payload="validatedPayload" @row-input="validateRow" :isProcessing="processingItems" :can-continue="canContinue" @submit="submitValidatedPayload" @cancel="cancelUpload" />
    </div>

    <div v-if="['create', 'process'].includes(state)" class="modal">
			<div id="upload_batch" v-if="state === 'create'">
				<p class="upload_title">Upload CSV File</p>
				<FileUpload @fileUploaded="processUpload" />
				<vue-csv-downloader
					class="primary-button"
					style="margin-left: auto; margin-right: auto;"
					:data="sampleData"
					:download-name="`BP_BATCH_ORDER_SAMPLE`"
					:fields="sampleHeaders"
					>Download Sample CSV File
				</vue-csv-downloader>
				<p @click="cancelBatch" class="cancel_batch">CLOSE</p>
			</div>
			<div id="upload_batch" v-if="state === 'process'">
				<p class="upload_title">Uploading CSV File</p>

				<div id="process_text">
					<p class="upload_text">Selected File: {{ fileName }}</p>
					<div id="progress_group">
						<span id="progress-bar">
							<span
								:style="{ width: `${percentageCompletion}%` }"
								id="top-bar"
							></span>
							<span id="bottom-bar"></span>
						</span>
						<span>{{ percentageCompletion }}%</span>
					</div>
				</div>
				<p @click="cancelBatch" class="cancel_batch">CLOSE</p>
			</div>
		</div>
		<div id="header">
			<div class="half_split">
				<div id="filter_group">
					<input
						class="filter_input"
						id="search"
						type="text"
						placeholder="Search Term"
						v-model="searchInput"
						@input="handleSearchInput"
					/>
					<select
						class="filter_input"
						v-model="vendType"
					>
						<option selected disabled value="">Vend Type</option>
						<option value="PREPAID">PREPAID</option>
						<option value="POSTPAID">POSTPAID</option>
					</select>
					<select class="filter_input" v-model="batchStatus">
						<option selected disabled value="">Status</option>
						<option value="NEW">NEW</option>
						<option value="INCOMPLETE">INCOMPLETE</option>
						<option value="COMPLETED">COMPLETED</option>
					</select>
					<input
						type="date"
						class="filter_input"
						name="filter_date"
						id="date_input"
						placeholder="Date"
						v-model="batchDate"
					/>
				</div>
				<div id="filter_buttons">
					<button
						class="filter_button"
						id="filter_button"
						@click="filterGroup"
					>
						Filter
					</button>
					<button
						class="filter_button"
						id="reset_button"
						@click="resetBatch"
					>
						Reset
					</button>
				</div>
			</div>
			<div class="half_split">
				<button
					@click="newBatch"
					class="filter_button primary_button"
					id="new_batch_button"
				>
					Run New Batch
				</button>
			</div>
		</div>

		<div id="orders-container">
			<table style="width: 100%;">
				<thead>
					<tr>
						<th>S/N</th>
						<th>DATE</th>
						<th>BATCH ID</th>
						<th>TYPE</th>
						<th>STATUS</th>
						<th>OPTIONS</th>
					</tr>
				</thead>
				<tbody class="alternate">
					<tr
						v-for="(row, rowKey) in dataBag.slice(0, page * 10)"
						v-bind:key="'row-' + rowKey"
						class="table-row"
					>
						<td>{{ rowKey + 1 }}</td>
						<td>
							<p>
								{{
									new Date(
										dataBag[rowKey]["created_at"]
									).toLocaleDateString("en-US", dateFormat)
								}}
							</p>
						</td>
						<td>
							<p>{{ dataBag[rowKey]["id"] }}</p>
						</td>
						<td>
							<p>Electricity</p>
							<!-- <p>{{ dataBag[rowKey]["business_id"] }}</p> -->
						</td>
						<td>
							<p
								v-bind:style="
									dataBag[rowKey]['status'] === 'SUCCESSFUL'
										? 'background: #D0ECDE'
										: dataBag[rowKey]['status'] === 'FAILED'
										? 'background: rgba(225, 82, 65, 0.2)'
										: 'background: rgba(241, 157, 56, 0.3)'
								"
								class="status_col"
							>
								{{ dataBag[rowKey]["status"] }}
							</p>
						</td>
						<td>
							<p
								class="view_details_btn"
								@click="viewBatch(dataBag[rowKey]['id'])"
							>
								View Details
							</p>
						</td>
					</tr>
				</tbody>
			</table>
			<p v-if="dataBag.length > 0" id="pagination_info">
				Showing
				<strong
					>1 -
					{{
						(page + 1) * 10 > dataBag.length
							? dataBag.length
							: page * 10
					}}</strong
				>
				of {{ dataBag.length }} Batches
			</p>
			<button
				@click="loadMore"
				class="filter_button primary_button"
				id="load_more_button"
				v-if="dataBag.length > 0"
			>
				Load More
			</button>
		</div>
		<md-snackbar
			md-position="center"
			:md-duration="6000"
			:md-active.sync="snackBar.show"
			md-persistent
		>
			<span>{{ snackBar.message }}</span>
		</md-snackbar>
	</div>
</template>
<script>
import debounce from 'lodash/debounce';
import Papa from 'papaparse';
import VueCsvDownloader from 'vue-csv-downloader';

import BatchPreview from '../../components/BatchPreview';
import FileUpload from '../../components/FileUpload';
import dataUtils from '../../utils/Data.util';
import http from '../../utils/Http.util';

import V from './utils';

const { batchOrderItemSchema, config } = V;

export default {
  data() {
    return {
      selectedFile: null,
      fileName: '',
      fileParsed: false,
      fileContents: [],
      errorRows: [],
      batchId: 0,
      validRows: [],
      batchOrders: [],
      dataBag: [],
      successItems: [],
      failedItems: [],
      validatedPayload: [],
      payloadToSend: [],
      processingError: false,
      processingItems: false,
      searchInput: '',
      currentProcess: '',
      state: '',
      vendType: '',
      batchStatus: '',
      batchDate: '',
      page: 1,
      percentageCompletion: 0,
      totalRows: 0,
      processedRows: 0,
      dateFormat: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
      failedItemsHeaderFields: ['data', 'invalid', 'error'],
      headerFields: [
        'batch_id',
        'order_id',
        'amount',
        'phone',
        'meter',
        'disco',
        'vend_type',
        'payment_type',
        'vertical',
      ],
      sampleData: [
        {
          order_id: 'A123',
          amount: '10000',
          phone: '08112345678',
          meter: '012345621',
          disco: 'ABUJA',
          vend_type: 'PREPAID',
          payment_type: 'B2B',
          vertical: 'ELECTRICITY',
        },
      ],
      sampleHeaders: [
        { label: 'Order Id', value: 'order_id' },
        { label: 'Amount', value: 'amount' },
        { label: 'Phone', value: 'phone' },
        { label: 'Meter', value: 'meter' },
        { label: 'Disco', value: 'disco' },
        { label: 'Vend Type', value: 'vend_type' },
        { label: 'Payment Type', value: 'payment_type' },
        { label: 'Vertical', value: 'vertical' },
      ],
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  components: {
    FileUpload,
    BatchPreview,
    VueCsvDownloader,
  },
  computed: {
    canContinue() {
      // Only allow continue if all rows are valid
      return (
        this.validatedPayload.length > 0
				&& this.validatedPayload.every((row) => row.isValid)
      );
    },
  },
  methods: {
    async validatePayload() {
      this.validatedPayload = await Promise.all(
        this.validRows.map((item) => this.validateRow(item)),
      );
    },
    async validateRow(row, index) {
      const result = {
        data: index >= 0 ? row.data : row,
        isValid: false,
        errors: {},
      };
      const validatedData = await batchOrderItemSchema
        .validate(result.data, { abortEarly: false })
        .then((res) => {
          result.isValid = true;
          if (index >= 0) {
            Object.keys(res).forEach((key) => {
              this.$set(row.data, key, res[key]);
            });

            this.$set(row, 'errors', {});
            this.$set(row, 'isValid', true);
          }
          return result;
        })
        .catch((err) => {
          err.inner.forEach((e) => {
            result.errors[e.path] = e.message;
          });
          if (index >= 0) {
            this.$set(row, 'errors', result.errors);
            this.$set(row, 'isValid', false);
          }
          return result;
        });
      return validatedData;
    },
    newBatch() {
      this.state = 'create';
    },
    cancelBatch() {
      this.state = '';
    },
    resetBatch() {
      this.dataBag = this.batchOrders;
    },
    viewBatch(id) {
      return this.$router.push(`/batch-order/${id}`);
    },
    loadMore() {
      this.page += 1;
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      this.fileName = this.selectedFile ? this.selectedFile.name : '';
    },
    async processUpload(file) {
      this.selectedFile = file;
      this.fileName = this.selectedFile ? this.selectedFile.name : '';
      this.state = 'process';
      await this.parseFile();

      if (this.validRows.length > config.MAX_BATCH_ORDER_PAYLOAD_SIZE) {
        this.snackBar = {
          show: true,
          message:
						`You cannot process a file with more than ${config.MAX_BATCH_ORDER_PAYLOAD_SIZE} items. Please split your batch order file.`,
        };
        this.selectedFile = null;
        this.fileName = '';
        this.state = '';
        return;
      }

      this.validatePayload();
      this.state = 'validate';
    },
    async parseFile() {
      if (!this.selectedFile) {
        this.snackBar = {
          show: true,
          message:
						'You have not selected a file. Please select a CSV file to process',
        };
        return;
      }
      const errors = [];
      const valid = [];
      return new Promise((resolve, reject) => {
        Papa.parse(this.selectedFile, {
          header: true,
          skipEmptyLines: true,
          step: function (row) {
            const { data } = row;
            this.processedRows += 1;
            this.percentageCompletion = Math.round(
              (this.processedRows / this.totalRows) * 100,
            );
            valid.push({ ...data, errors: [], isRowValid: false }); // default row to invalid
          }.bind(this),
          beforeFirstChunk: function (chunk) {
            this.totalRows = chunk.split('\n').length - 1;
            this.processedRows = 0;
          }.bind(this),
          complete: function (results) {
            this.errorRows = errors;
            this.validRows = [...valid];
            this.fileContents = results;
            this.fileParsed = true;
            this.state = 'process';

            resolve(this.validRows);
          }.bind(this),
        });
      });
      this.$store.commit('busyStatus', false);
    },
    handleSearchInput() {
      this.$router.push(`?search=${this.searchInput}`);

      this.filterTable(this.searchInput);
    },
    filterGroup() {
      this.dataBag = this.batchOrders;
      if (this.batchStatus) {
        this.dataBag = this.dataBag.filter(
          (order) => order.status === this.batchStatus,
        );
      }
      if (this.batchDate) {
        this.dataBag = this.dataBag.filter(
          (order) => order.created_at.split('T')[0] === this.batchDate,
        );
      }
      if (this.vendType) {
        this.dataBag = this.dataBag.filter(
          (order) => order.payload && order.payload.some((item) => item.vendType === this.vendType),
        );
      }
    },
    filterTable(searchTerm) {
      const f = debounce(() => {
        if (!searchTerm) {
          this.dataBag = this.batchOrders;
          return;
        }
        this.dataBag = dataUtils.filterData(
          this.batchOrders,
          searchTerm,
        );
      }, 2000);
      f();
    },
    cancelUpload() {
      this.validatedPayload = [];
      this.validRows = [];
      this.selectedFile = null;
      this.state = '';
    },
    async processFile() {
      this.processingError = false;
      const batchCreationReqBody = this.formatFileForBatchOrderCreation(
        this.payloadToSend,
      );
      // FIRE CREATE BATCH ORDER REQUEST
      await http
        .authReq(
          '/dashboard/batch-orders',
          batchCreationReqBody,
          'post',
        )
        .then(async (data) => {
          this.state = 'process';
          this.batchId = data.data.id;
          this.$router.push(`/batch-order/${this.batchId}`);
          this.$store.commit('busyStatus', false);
        })
        .catch((err) => {
          this.processingError = true;
          this.snackBar = {
            show: true,
            message: `Error processing data ::: ${err.message}`,
          };
          this.$store.commit('busyStatus', false);
        })
        .finally(() => {
          this.$store.commit('busyStatus', false);
        });
    },
    async submitValidatedPayload() {
      if (this.processingItems) {
        this.snackBar = {
          show: true,
          message: 'Batch Order Is Already Being Processed. Please Wait.',
        };
      }
      this.processingItems = true;
      // create a new array with only the data field
      this.payloadToSend = this.validatedPayload.map((row) => row.data);
      await this.processFile();
    },
    formatFileForBatchOrderCreation(file) {
      return {
        payload: file.map((item) => ({
          batchId: item['Batch Id'],
          orderId: item['Order Id'],
          amount: item.Amount,
          disco: item.Disco,
          meter: item.Meter,
          phone: item.Phone,
          paymentType: item['Payment Type'],
          vendType: item['Vend Type'],
          vertical: item.Vertical,
        })),
      };
    },
    async fetchBatchOrders() {
      // this.$store.commit('busyStatus', true);
      const { data } = await http.authReq('/dashboard/batch-orders');
      this.$store.commit('setBatchOrders', data);
      this.batchOrders = data.batchOrders || [];
      this.dataBag = data.batchOrders || [];
      // this.$store.commit('busyStatus', false);

      const searchTerm = this.$route.query.search;
      this.filterTable(searchTerm);
    },
  },
  mounted() {
    // fetch all batch orders created by user;
    this.fetchBatchOrders();
  },
};
</script>

<style scoped>
#app {
	max-width: 400px;
	margin: auto;
	text-align: center;
}

.modal {
	position: fixed;
	width: 100%;
	height: 750px;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.5);
	z-index: 999999999;
	display: flex;
	justify-content: center;
	align-items: center;
}

#upload_batch {
	width: 800px;
	height: auto;
	border-radius: 8px;
	background: #fff;
	padding: 40px;
	box-sizing: border-box;
	position: relative;
}

.upload_title {
	font-family: "Inter";
	font-weight: 500;
	font-size: 18px;
	margin-bottom: 42px;
}

.upload_text {
	font-family: "Open Sans";
	font-size: 16px;
	font-weight: 400;
	color: #6d6d6d;
}

.view_details_btn {
	font-size: 14px;
	color: #8ca32b;
	font-family: "Open Sans";
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
}

.view_details_btn:hover {
	opacity: 1;
	cursor: pointer;
}

.status_col {
	text-transform: capitalize;
	padding: 4px 12px;
	border: none;
	border-radius: 50px;
	text-align: center;
}

#header {
	width: 100%;
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	margin-bottom: 24px;
}

#filter_group {
	display: flex;
	flex-flow: row nowrap;
	margin-bottom: 24px;
}

.filter_input {
	border: none;
	border-bottom: solid 1px #aaaaaa;
	font-size: 12px;
	font-family: "Open Sans";
	font-weight: 400;
	color: #aaaaaa;
	background: none;
	padding: 4px 0px;
	margin-right: 8px;
}

.filter_button {
	padding: 8px 21px;
	border: none;
	border-radius: 4px;
	font-size: 16px;
	color: #fff;
	margin-right: 8px;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
}

.filter_button:hover {
	cursor: pointer;
	opacity: 1;
}

.half_split {
	width: 50%;
}

#reset_button {
	background: #e15241;
}

#filter_button {
	background: #67ad5b;
}

.primary_button {
	background: #f19d38;
	display: block;
}

#new_batch_button {
	margin-left: auto;
}

input[type="file"] {
	margin: 20px 0;
}

.input-group {
	display: flex;
	flex-flow: column nowrap;
	width: 500px;
	margin: 0 auto;
}

.input-group > input {
	width: 100%;
}

.input-group > p {
	margin-top: 16px;
}

.button {
	width: 100%;
	background: #ff9800;
	color: #fff;
	height: 60px;
	border: none;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
	max-width: 500px;
	margin: 0 auto;
	display: block;
	margin-top: 16px;
}

.button:hover {
	cursor: pointer;
	opacity: 1;
}

.file-contents {
	width: 100%;
	overflow: scroll;
	height: auto;
	max-height: 600px;
}

.processed-item {
	width: 100%;
	height: auto;
	border: solid 1px #aaa;
	border-radius: 8px;
	margin-bottom: 8px;
	padding: 16px;
	box-sizing: border-box;
}

.success {
	background: #b0f4ba;
	border: solid 1px#09ff00;
}

.failed {
	background: #ffaaaa;
	border: solid 1px #ff0000;
}

.processed-item-metadata {
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
}

.processed-item-metadata .metadata-item {
	width: 29%;
}

.loaderContainer {
	position: relative;
	height: 30px;
	width: 100%;
}

.table-row {
	height: 50px;
	opacity: 1;
	transition: all 0.5s ease-in-out;
}

.table-row :hover {
	opacity: 1;
	cursor: pointer;
}

table {
	width: 100%;
	border-collapse: collapse; /* Ensures borders are collapsed into a single border */
	font-family: "Open Sans";
	font-weight: 400;
	margin-bottom: 16px;
	height: 500px;
	scrollbar-width: none;
	overflow-y: scroll;
}

table::-webkit-scrollbar {
	display: none; /* Hides the scrollbar */
}

table th {
	color: #67ad5b;
	font-weight: 400;
}

table th,
table td {
	padding: 10px;
	text-align: left;
	/* border: none; Removes borders from table cells */
}

table tr {
	border: none;
	border-bottom: solid 1px rgba(170, 170, 170, 0.3);
	background: #fff;
}

/* .alternate :nth-of-type(even) {
  background: rgba(255, 152, 0, 0.3);
} */

#create-button {
	width: fit-content;
	padding: 4px 16px;
	margin: 0;
	margin-left: auto;
	border-radius: 8px;
	display: block;
}

#progress_group {
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	height: 40px;
	line-height: 40px;
}

#progress-bar {
	width: 500px;
	position: relative;
	margin-right: 8px;
}

#top-bar {
	position: absolute;
	background: #8ca32b;
	border: none;
	border-radius: 4px;
	height: 8px;
	z-index: 99;
	top: 0px;
	left: 0px;
}

#bottom-bar {
	position: absolute;
	background: #eeeeee;
	border: none;
	border-radius: 4px;
	height: 8px;
	width: 100%;
	top: 0px;
	left: 0px;
	z-index: 9;
}

#process_text {
	width: 600px;
	margin: 0 auto;
}

#process_text span {
	display: block;
}

.cancel_batch {
	width: 100%;
	text-align: right;
	font-family: "Open Sans";
	font-size: 16px;
	font-weight: 400;
	color: #6d6d6d;
	margin-top: 32px;
}

.cancel_batch:hover {
	cursor: pointer;
}

#pagination_info {
	font-family: "Open Sans";
	font-size: 16px;
	color: #6d6d6d;
	font-weight: 300;
}

.primary-button {
	background: #67ad5b;
	color: #ffffff;
	width: fit-content;
	font-size: 16px;
	padding: 12px 24px;
	margin: 16px 0px;
	border: none;
	border-radius: 4px;
	border: solid 1px #67ad5b;
	display: block;
	opacity: 0.8;
	transition: all 0.25s ease-in-out;
}

.primary-button a {
	display: block;
	height: 100%;
	color: #fff;
	text-decoration: none;
}

.primary-button:visited {
	color: #fff;
	text-decoration: none;
}

.primary-button:focus {
	color: #fff;
	text-decoration: none;
}
</style>
